export const config = {
  API_URL: process.env.REACT_APP_API_URL || "http://103.185.212.117:5077/api",
}

// Stripe configuration - only what's needed
export const paymentConfig = {
  stripe: {
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISH_KEY,
  }
}


